import React from 'react';

const JungleMascot: React.FC<{
  style?: React.CSSProperties;
  className?: string;
}> = ({ style, className }) => (
  <svg
    viewBox="0 0 32 32"
    width="1em"
    height="1em"
    style={style}
    className={className}
  >
    <defs>
      <linearGradient id="jungle-body" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#10b981" />
        <stop offset="100%" stopColor="#065f46" />
      </linearGradient>
    </defs>
    {/* Tail feathers */}
    <path
      d="M22 22 Q28 18 27 12"
      fill="none"
      stroke="#f97316"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M21 23 Q29 20 26 14"
      fill="none"
      stroke="#fbbf24"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    {/* Body (teardrop) */}
    <path
      d="M16 6 Q8 14 10 22 Q12 28 20 28 Q24 28 24 22 Q26 14 16 6Z"
      fill="url(#jungle-body)"
    />
    {/* Wing accent */}
    <path d="M11 16 Q8 18 9 22 Q12 20 14 17Z" fill="#fbbf24" />
    {/* Eye */}
    <circle cx="15" cy="14" r="1.8" fill="white" />
    <circle cx="15.4" cy="13.8" r="0.9" fill="#1a1a1a" />
    {/* Beak */}
    <path d="M12 16 L8 17.5 L12 18" fill="#f97316" />
    {/* Feet */}
    <line
      x1="14"
      y1="28"
      x2="13"
      y2="31"
      stroke="#f97316"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <line
      x1="18"
      y1="28"
      x2="19"
      y2="31"
      stroke="#f97316"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
  </svg>
);

export default JungleMascot;
